import React from "react";
import { useParams } from "react-router-dom";
import servicesData from "./servicedata"; // create and export this
import ServiceShowcase from "./serviceshowcase";

const ServiceShowcasePage = () => {
  const { slug } = useParams();

  const selectedService = servicesData.find(
    (s) => s.title.toLowerCase().replace(/\s+/g, "-") === slug
  );

  if (!selectedService) return <h2>Service not found</h2>;

  return (
    <div style={{ padding: "60px" }}>
      <h2>{selectedService.title}</h2>
      <p style={{ maxWidth: "800px" }}>{selectedService.details}</p>
      <ServiceShowcase sections={selectedService.cards} />
    </div>
  );
};

export default ServiceShowcasePage;
